(() => {
  const ensureVariantContrastStyles = () => {
    if (document.getElementById('nrnl-variant-contrast')) return;

    const style = document.createElement('style');
    style.id = 'nrnl-variant-contrast';
    style.textContent = `
      main[data-template^="product"] .variant-option__button-label:has(input:checked) {
        border-color: #b0955c !important;
        background: #1a1813 !important;
        color: #f2f0eb !important;
        opacity: 1 !important;
        font-weight: 700 !important;
      }

      body.nrnl-product-raw main[data-template^="product"] .variant-option__button-label:has(input:checked) {
        border-color: #ff3f34 !important;
        background: #260908 !important;
        color: #f2f0eb !important;
      }

      main[data-template^="product"] .variant-option__button-label:has(input[aria-disabled="true"]) {
        opacity: 0.72 !important;
        background: #0a0a0a !important;
        color: #c0bbb2 !important;
      }
    `;
    document.head.appendChild(style);
  };

  const normalizeLuxuryCoreLinks = () => {
    document.querySelectorAll('a[href="/luxury-core"]').forEach((link) => {
      link.setAttribute('href', '/collections/luxury-core');
    });
  };

  ensureVariantContrastStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeLuxuryCoreLinks, { once: true });
  } else {
    normalizeLuxuryCoreLinks();
  }

  document.addEventListener('shopify:section:load', () => {
    ensureVariantContrastStyles();
    normalizeLuxuryCoreLinks();
  });
})();